module.exports = ":host mat-radio-button {\n  margin-right: 1rem; }\n"